import { Box, Button, Grid, TextField, InputLabel, Autocomplete } from "@mui/material";
import ArrowForward from "@mui/icons-material/ArrowForward";

const FilterItems = ({
  filterData,
  handleChangeFilter,
  handleFilter,
  handleClearFilters,
  reasonTypes, // list of reason types from API
}) => {
  return (
    <Grid container spacing={2}>
      {/* Reason Type Autocomplete Filter */}
      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Reason Type
        </InputLabel>
        <Autocomplete
          disablePortal
          options={reasonTypes}
          getOptionLabel={(option) => option.name || option}
          value={
            filterData.reason_type
              ? reasonTypes.find((r) => r.id === filterData.reason_type || r === filterData.reason_type)
              : null
          }
          onChange={(_, newValue) => {
            handleChangeFilter("reason_type")(null, newValue ? (newValue.id || newValue) : "");
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              placeholder="Select Reason Type"
            />
          )}
        />
      </Grid>

      <Grid item xs={12}>
        <Box textAlign="right">
          <Button
            variant="outlined"
            onClick={handleClearFilters}
            sx={{
              marginRight: 2,
              textTransform: "none",
              color: "#48505E",
              borderColor: "#E0E0E0",
            }}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            onClick={handleFilter}
            endIcon={<ArrowForward />}
            sx={{
              backgroundColor: "#7152F3",
              textTransform: "none",
              "&:hover": {
                backgroundColor: "#5c34fa",
              },
            }}
          >
            Filter
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default FilterItems;